import axios from "axios";
import * as localforage from "localforage";
import { successHandling } from "../helpers/successHandling";
import textNoty from "../helpers/textNoty";

export const getTagsApi = async (
  search,
  order_by_field,
  order_by_type,
  page,
  paginate
) => {
  let res = await axios({
    url: `/api/v2/tag/table`,
    method: "GET",
    params: {
      search,
      order_by_field,
      order_by_type,
      page,
      paginate
    }
  });
  return res.data;
};

export const createTagApi = async (name, t, successfulText) => {
  try {
    let res = await axios({
      url: `/api/v2/tag/create`,
      method: "POST",
      data: {
        name
      }
    });
    successHandling(t, successfulText);
    return res.data;
  } catch (error) {
    if (error?.response?.data?.errors?.name[0] === "name_already_exist") {
      textNoty(t("error.alreadyExist"));
    }
  }
};

export const deleteTagApi = async (tag_ids, t, successfulText) => {
  let res = await axios({
    url: `/api/v2/tags/delete`,
    method: "DELETE",
    data: {
      tag_ids
    }
  });
  successHandling(t, successfulText);
  return res.data;
};

export const updateTagApi = async (tag_id, name, t, successfulText) => {
  try {
    let res = await axios({
      url: `/api/v2/tag/update`,
      method: "PUT",
      data: {
        tag_id,
        name
      }
    });
    successHandling(t, successfulText);
    return res.data;
  } catch (error) {
    if (
      error?.response?.data?.errors?.name[0] ===
      "The name has already been taken."
    ) {
      textNoty(t("error.alreadyExist"));
    }
  }
};
